import { AvatarSex } from '@seddi/avatar';
import { SessionData } from '../session';

export enum MessageType {
  APP_LOADED_EVENT = 'fitroom.app.loaded.evt',
  AVATAR_FROM_SMPL_REQ = 'fitroom.avatar.smpl.req',
  AVATAR_FROM_STAR_REQ = 'fitroom.avatar.star.req',
  CREDENTIALS_REQ = 'fitroom.credentials.req',
  CREDENTIALS_RES = 'fitroom.credentials.res',
  GARMENT_REQ = 'fitroom.garment.req',
  GARMENT_SKU_REQ = 'fitroom.garment.sku.req',
  GARMENT_UPDATED_EVENT = 'fitroom.garment.updated.evt',
  SESSION_REQ = 'fitroom.session.req',
  SESSION_RES = 'fitroom.session.res',
}

export type MessageIncomingType =
  | MessageType.AVATAR_FROM_SMPL_REQ
  | MessageType.AVATAR_FROM_STAR_REQ
  | MessageType.CREDENTIALS_RES
  | MessageType.GARMENT_REQ
  | MessageType.GARMENT_SKU_REQ
  | MessageType.SESSION_REQ;

// Payload types.

export type AvatarFromSmplReqPayload = {
  sex: AvatarSex;
  smplShape: number[]; // { length: 300 }
};

export type AvatarFromStarReqPayload = {
  sex: AvatarSex;
  starShape: number[]; // { length: 300 }
};

export type CredentialsResPayload = {
  appKey: string;
  origin?: string;
};

export type GarmentReqPayload = {
  id: string;
  isSizeRecommendation?: boolean;
};

// Message types.

export type AppLoadedEvent = {
  type: MessageType.APP_LOADED_EVENT;
};

export type AvatarFromSmplReq = {
  type: MessageType.AVATAR_FROM_SMPL_REQ;
  payload: AvatarFromSmplReqPayload;
};

export type AvatarFromStarReq = {
  type: MessageType.AVATAR_FROM_STAR_REQ;
  payload: AvatarFromStarReqPayload;
};

export type CredentialsReq = {
  type: MessageType.CREDENTIALS_REQ;
};

export type CredentialsRes = {
  type: MessageType.CREDENTIALS_RES;
  payload: CredentialsResPayload;
};

export type GarmentReq = {
  type: MessageType.GARMENT_REQ;
  payload: GarmentReqPayload;
};

export type GarmentSkuReq = {
  type: MessageType.GARMENT_SKU_REQ;
  payload: string;
};

export type GarmentUpdatedEvent = {
  type: MessageType.GARMENT_UPDATED_EVENT;
  payload: string;
};

export type SessionReq = {
  type: MessageType.SESSION_REQ;
  payload: string;
};

export type SessionRes = {
  type: MessageType.SESSION_RES;
  payload: SessionData;
};

export type MessageIncoming =
  | AvatarFromSmplReq
  | AvatarFromStarReq
  | CredentialsRes
  | GarmentReq
  | GarmentSkuReq
  | SessionReq;

export type MessageOutgoing = AppLoadedEvent | CredentialsReq | GarmentUpdatedEvent | SessionRes;

export type Message = MessageIncoming | MessageOutgoing;
